<template>
  <div
    class="slide-section-main office-loaction-inner slider-provider"
    :class="{
      'remove-top': currentRoute === 'AppointmentDetail'
    }"
    style="display: block;"
  >
    <header-vue :my-return="myReturn" title="Provider" :long-title="true" />
    <div class="slide-section-area-wrapper">
      <div class="seprator top"></div>
      <div class="slide-section-inner-wrapper">
        <ul class="check-list">
          <template v-for="(provider, index) in providers">
            <li
              :key="provider.id"
              @click="optionSelected(index)"
              :class="{ active: selectedId === provider.id }"
              v-if="!provider.permission_id && !provider.permission_status"
            >
              <span>
                <object
                  class="svg-back-arrow"
                  :data="checkSvg"
                  type="image/svg+xml"
                ></object>
              </span>
              <span>
                {{
                  formatName(
                    provider.firstName,
                    provider.middleName,
                    provider.lastName,
                    provider.namePrefix,
                    provider.nameSuffix
                  )
                }}
              </span>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderVue from "./common/Header.vue";
import { mapGetters, mapMutations } from "vuex";
import { nameMixin } from "../../../../mixins/nameMixin.js";
import { providerDependentMixin } from "../../../../mixins/providerDependentMixin";

export default {
  mixins: [nameMixin, providerDependentMixin],
  props: {
    done: Function
  },
  data() {
    return {
      checkSvg: require("../../../../assets/svg/check-mark.svg")
    };
  },
  computed: {
    ...mapGetters({
      getProviders: "getProvider" // Get the provider details
    }),
    /**
     * Returns a list of providers
     */
    providers() {
      return this.getProviders.list;
    },
    /**
     * Returns the selected provider id
     */
    selectedId() {
      return this.providers[this.getProviders.selectedIndex].id;
    },
    /**
     * Gets the current route in the user is at currently
     */
    currentRoute() {
      return this.$router.history.current.name;
    }
  },
  methods: {
    ...mapMutations({
      setProvider: "setProvider" // Set provider selected Index
    }),
    /**
     * Function when an options is selected
     */
    optionSelected(index) {
      this.setProvider(index);
      this.done();
    },
    myReturn() {
      this.done();
    }
  },
  components: {
    HeaderVue
  }
};
</script>

<style scoped>
li {
  cursor: pointer;
}

.slide-section-main {
  overflow: unset;
  top: 108px;
}

.remove-top {
  top: 97px !important;
}
</style>
